import React from "react";

const PropertyListing = () => (
  <section id="listing" className="w-full min-w-full h-full flex-shrink-0 snap-start flex items-center justify-center bg-gray-100 p-4 sm:p-6 md:p-8 overflow-y-auto">
    <div className="text-center max-w-4xl w-full bg-white rounded-lg shadow-xl p-4 sm:p-6 md:p-8 my-4 sm:my-0">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">Property Listings</h1>
      <h2 className="text-xl sm:text-2xl md:text-3xl mb-6 sm:mb-8">St. Louis and Surrounding Missouri Counties</h2>
      <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-12"><span className="font-bold text-black px-2 py-1 rounded">Driscoll Co. RealEstate Services</span> proudly presents a curated selection of available listings in St. Louis and surrounding Missouri counties.</p>
      <div className="relative w-full h-[min(70vh,600px)] sm:h-[650px] md:h-[700px] border border-gray-300 rounded-lg overflow-hidden shadow-lg mt-6 sm:mt-12">
        <iframe src="https://mar.mlsmatrix.com/Matrix/public/IDX.aspx?idx=ac1dce" className="absolute inset-0 w-full h-full" frameBorder="0" title="MLS Listings" onLoad={(e) => (e.target.style.opacity = 1)} style={{ opacity: 0, transition: "opacity 0.5s ease-in-out" }} />
      </div>
    </div>
  </section>
);

export default PropertyListing;
